import API from '@teamleader/api';
import jwtDecode from 'jwt-decode';
import { filter, identity } from 'ramda';

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './constants';

const getLanguageFromSessionStorage = () => {
  try {
    const sessionStorageData = JSON.parse(sessionStorage.getItem('accountSetup'));
    if (sessionStorageData?.accountSettings?.language) {
      return sessionStorageData.accountSettings.language;
    }
  } catch {}
};

const getTokenLanguage = (token) => {
  if (!token) {
    return;
  }

  try {
    const tokenData = jwtDecode(token);
    return tokenData?.language;
  } catch {}
};

const getUserProfileLanguage = async (accessToken) => {
  try {
    const { users } = API({
      baseUrl: TEAMLEADER_API,
      accessToken,
    });

    const { data } = await users.me();
    if (data.language) {
      return data.language;
    }
  } catch {}
};

export const getQueryParamLanguage = (lang) => {
  return lang?.toLowerCase();
};

export const getBrowserLanguage = () => {
  const browserLanguage = navigator.language;

  if (browserLanguage.indexOf(DEFAULT_LANGUAGE) !== -1) {
    return undefined;
  }

  return browserLanguage;
};

export const getLanguage = async (locationState, accessToken) => {
  const getLanguageSteps = filter(identity, [
    getLanguageFromSessionStorage,
    locationState?.query?.token ? () => getTokenLanguage(locationState.query.token) : undefined,
    accessToken ? async () => await getUserProfileLanguage(accessToken) : undefined,
    locationState?.query?.lang ? () => getQueryParamLanguage(locationState.query.lang) : undefined,
    getBrowserLanguage,
  ]);

  for (let i = 0; i < getLanguageSteps.length; i += 1) {
    const expectedLanguage = await getLanguageSteps[i]();

    if (expectedLanguage) {
      const validLanguage = SUPPORTED_LANGUAGES.find((lang) => lang.toLowerCase() === expectedLanguage.toLowerCase());
      if (validLanguage) {
        return validLanguage;
      }
    }
  }

  return DEFAULT_LANGUAGE;
};
